import { forwardRef, type ButtonHTMLAttributes, type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';

export interface SelectableCardListProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function SelectableCardList({ className, children, ...props }: SelectableCardListProps) {
  return (
    <div className={cn('selectable-card-list', className)} {...props}>
      {children}
    </div>
  );
}

export interface SelectableCardProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'value' | 'title'
> {
  selected?: boolean;
  title: ReactNode;
  value?: ReactNode;
  meta?: ReactNode;
  sub?: ReactNode;
  badge?: ReactNode;
  children?: ReactNode;
}

/** Clickable surface card — protótipo comanda Caixa sidebar. */
export const SelectableCard = forwardRef<HTMLButtonElement, SelectableCardProps>(
  function SelectableCard(
    {
      selected = false,
      title,
      value,
      meta,
      sub,
      badge,
      className,
      children,
      type = 'button',
      ...props
    },
    ref,
  ) {
    return (
      <button
        ref={ref}
        type={type}
        className={cn('selectable-card', selected && 'selectable-card--selected', className)}
        {...props}
      >
        <div className="selectable-card__row">
          <span className="selectable-card__title">{title}</span>
          {badge}
          {value ? <span className="selectable-card__value">{value}</span> : null}
        </div>
        {meta ? <div className="selectable-card__meta">{meta}</div> : null}
        {sub ? <div className="selectable-card__sub">{sub}</div> : null}
        {children}
      </button>
    );
  },
);
